import { render, staticRenderFns } from "./BasicActions.vue?vue&type=template&id=b0d6dbc4&scoped=true"
import script from "./BasicActions.vue?vue&type=script&lang=js"
export * from "./BasicActions.vue?vue&type=script&lang=js"
import style0 from "./BasicActions.vue?vue&type=style&index=0&id=b0d6dbc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d6dbc4",
  null
  
)

export default component.exports